import * as React from "react";
const SvgTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 10, viewBox: "0 0 13 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.5 10L0.870835 0.25L12.1292 0.250001L6.5 10Z", fill: "black" }));
export default SvgTriangle;
